import { render } from "./CreateGuestPage.vue?vue&type=template&id=1a6b6d6c"
import script from "./CreateGuestPage.vue?vue&type=script&lang=js"
export * from "./CreateGuestPage.vue?vue&type=script&lang=js"

import "@/css/GuestsPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__